import { ReportSummaryRow, ClassRow } from './reports-model';

export class PayrollClassItem extends ClassRow {
}

export class PayrollInstructorSummary extends ReportSummaryRow {
    categories: PayrollCategorySummary[];
    constructor(public instructorName: string, public instructorAdpId: string) {
        super();
        this.categories = [];
        this.totalCost = 0;
        this.totalHours = 0;
    }
}

// Second level of grouping by the Class Category + Job Cost Code + Instructor’s hourly rate applicable for this Category

export class PayrollCategorySummary extends ReportSummaryRow {
    classes: PayrollClassItem[];
    constructor(
        public categoryCode: string,
        public categoryName: string,
        public jobCostCode: string,
        public jobCostCodeDescription: string,
        public hourlyRate: number) {
        super();
        this.classes = [];
        this.totalCost = 0;
        this.totalHours = 0;
    }
}
